import { Checkbox, DataHeader, DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutPartialShipmentControl extends Layout {
    checkboxCreateManifestOnHold: Checkbox;
    checkboxEnableManifesting: Checkbox;
    dataheaderTitle: DataHeader;
    sourcePartialShipmentControl: DataSource;
}
